<template>
    <v-container>
        <v-progress-linear indeterminate v-if="loadingSpecimen"></v-progress-linear>
        <v-row v-if="!loadingSpecimen">
            <v-col cols="12">
                <v-row>
                    <v-col cols="12">
                        <v-card>
                            <v-card-title class="text-center">
                                <div class="title">
                                    Specimen: {{currentSpecimen.SpecimenDisplayID}}
                                </div>
                                <v-spacer></v-spacer>
                                <v-btn
                                    class="ml-4"
                                    color="success"
                                    @click="openHusbandry"
                                >
                                    Open Husbandry
                                </v-btn>
                            </v-card-title>
                            <v-card-text>
                                <v-row >
                                    <v-col cols="12" sm="12" md="6" >
                                        <v-row  class="specimen-details">
                                            <v-col cols="4" sm="3" class="specimen-details-header">
                                                Gender
                                            </v-col>
                                            <v-col cols="8" sm="9">
                                                {{ genderFull}}
                                            </v-col>
                                        </v-row>
                                        <v-row  :class="`specimen-details ${lastCleanClass}`">
                                            <v-col cols="4" sm="3" class="specimen-details-header">
                                                Drawer
                                            </v-col>
                                            <v-col cols="8" sm="9">
                                                {{ currentSpecimen.DrawerText}}
                                            </v-col>
                                        </v-row>
                                        <v-row  class="specimen-details">
                                            <v-col cols="4" sm="3" class="specimen-details-header">
                                                Location
                                            </v-col>
                                            <v-col cols="8" sm="9">
                                                {{ locationFullText }}
                                            </v-col>
                                        </v-row>
                                        <v-row  class="specimen-details">
                                            <v-col cols="4" sm="3" class="specimen-details-header">
                                                Supplier
                                            </v-col>
                                            <v-col cols="8" sm="9">
                                                {{ currentSpecimen.SupplierName}}
                                            </v-col>
                                        </v-row>
                                        <v-row  class="specimen-details">
                                            <v-col cols="4" sm="3" class="specimen-details-header">
                                                Room
                                            </v-col>
                                            <v-col cols="8" sm="9">
                                                {{ currentSpecimen.RoomText}}
                                            </v-col>
                                        </v-row>
                                        <v-row  class="specimen-details">
                                            <v-col cols="4" sm="3" class="specimen-details-header">
                                                Rack Number
                                            </v-col>
                                            <v-col cols="8" sm="9">
                                                {{ currentSpecimen.RackNumber}}
                                            </v-col>
                                        </v-row>
                                        <v-row  class="specimen-details">
                                            <v-col cols="4" sm="3" class="specimen-details-header">
                                                Arrival Date
                                            </v-col>
                                            <v-col cols="8" sm="9">
                                                {{ displayArrivalDate}}
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6" >
                                        <DailyHusbandryWeightHistory :history="currentSpecimen.WeightHistory">
                                        </DailyHusbandryWeightHistory>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import moment from 'moment';
import validationRules from "../../helpers/validationrules";
import GlobalEventBus from '@/globalEventBus';
import DailyHusbandryWeightHistory from "../../components/specimens/DailyHusbandryWeightHistory.vue";
import * as auth from '@/services/auth';
import permissions from 'comunet-btg-utah-repository-shared/permissions';
import constants from 'comunet-btg-utah-repository-shared/constants';
import MedicalRecordAPI from '../../services/medicalRecordAPI';
import { mapState } from 'vuex';

export default {
    components: {
        DailyHusbandryWeightHistory
    },
    props: {

    },
    data() {
        return {
            currentSpecimen: {},
            rules: validationRules.rules,
            enteredSpecimenID: "",
            loadingSpecimen: false,
            panel: null,
            totalMedicalRecords: 0,
        };
    },
    computed: {
        locationFullText() {
            return [this.currentSpecimen.LocationTypeText, this.currentSpecimen.RoomText, this.currentSpecimen.SuiteNumberText, this.currentSpecimen.RackNumber, this.currentSpecimen.DrawerText].filter(x => x).join(" - ");
        },
        specimenLoaded() {
            return !this.loadingSpecimen && this.currentSpecimen != null && this.currentSpecimen.SpecimenID && this.currentSpecimen.SpecimenID > 0;
        },
        specimenDisplayID() {
            return this.$route.query.SpecimenDisplayID;
        },
        displayArrivalDate: {
            get: function() {
                if (this.currentSpecimen && this.currentSpecimen.ArrivalDate) {
                    return moment.utc(this.currentSpecimen.ArrivalDate).format(constants.DATE_FORMAT_NO_TIME);
                }

                return "";
            },
            set: function(newValue) {
                this.currentSpecimen.ArrivalDate = newValue;
            }
        },
        genderFull() {
            if (this.currentSpecimen.Gender === "M") {
                return "Male";
            }

            if (this.currentSpecimen.Gender === "F") {
                return "Female";
            }
            // gender can be null
            return "";
        },
        saveError() {
            return this.$store.state.specimenStore.saveError;
        },
    },
    methods: {
        loadSpecimen() {
            this.loadingSpecimen = true;
            this.currentSpecimen = {};

            let that = this;
            this.$store.dispatch("specimenStore/loadSpecimens", {
                params: {
                    SpecimenDisplayID: this.specimenDisplayID
                },
                success: (data) => {
                    if (!(data.TotalSpecimens != 1)){
                        that.currentSpecimen = data.Specimens.map(function (l){
                            var species = that.$store.state.speciesStore.species.find(x => x.SpeciesID == l.SpeciesID);
                            l.Species = species;

                            var supplier = that.$store.state.supplierStore.suppliers.find(x => x.SupplierID == l.SupplierID);
                            l.Supplier = supplier;

                            return l;
                        })[0]

                        that.validSpecimen = true;
                    }
                },
                finally: () => {
                    that.loadingSpecimen = false;
                }
            });
        },
        openHusbandry() {
            this.$router.push({ name: 'husbandrywithid', params: { specimenDisplayID: this.specimenDisplayID } });
        }
    },
    async created() {
        if(this.specimenDisplayID) {
           await this.loadSpecimen();
        }

    },
};
</script>

<style scoped>
    .specimen-details .specimen-details-header {
        font-weight: bold;
    }

    .specimen-details .flex {
        min-height: 36px;
        font-size: 120%;
    }

    .location-buttons .first {
        padding-right: 5px;
    }

    .location-buttons .second {
        padding-left: 5px;
    }
</style>